import Future from 'fluture';
import cookies from 'browser-cookies';
import * as r from 'ramda';
import * as rA from 'ramda-adjunct';

export default function createFetchOpts(
) {
  return function fetchOpts(
    settings
  ) {
    const cookieValues = r.pipe(
      r.defaultTo(''),
      r.split('|'),
      r.unless(
        r.isEmpty,
        r.pipe(
          r.drop(1),
          r.map(r.split(':')),
        ),
      )
    )(cookies.get('OPTOUTMULTI'));

    const values = r.pipe(
      r.map((category) => {
        return r.pipe(
          r.find(r.propEq(0, category.id)),
          r.prop(1),
          r.ifElse(
            r.equals('0'),
            r.T,
            r.F,
          ),
        )(cookieValues);
      }),
    )(settings);

    return Future.of(values);
  }
}



// WEBPACK FOOTER //
// ./src/infrastructure/fetchOpts.js